import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-topbar-layout',
    templateUrl: './topbar-layout.component.html',
    styleUrls: ['./topbar-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopbarLayoutComponent {}
